/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReleaseStatus } from './ReleaseStatus';
import {
    ReleaseStatusFromJSON,
    ReleaseStatusFromJSONTyped,
    ReleaseStatusToJSON,
    ReleaseStatusToJSONTyped,
} from './ReleaseStatus';

/**
 * The LAUNCH, not the thing being launched — two fields, and the count
 * is the point. Art, logo, tagline, synopsis, store link, trailer,
 * video strip, hero rail, platforms and category identity are all true
 * whether or not a title has shipped, so they live on the Drop. Only
 * the date and the phase describe a launch.
 * 
 * @export
 * @interface DropRelease
 */
export interface DropRelease {
    /**
     * Epoch ms. Absent while a title is announced with no date.
     * @type {number}
     * @memberof DropRelease
     */
    releaseDate?: number;
    /**
     * 
     * @type {ReleaseStatus}
     * @memberof DropRelease
     */
    status: ReleaseStatus;
}



/**
 * Check if a given object implements the DropRelease interface.
 */
export function instanceOfDropRelease(value: object): value is DropRelease {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function DropReleaseFromJSON(json: any): DropRelease {
    return DropReleaseFromJSONTyped(json, false);
}

export function DropReleaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropRelease {
    if (json == null) {
        return json;
    }
    return {
        
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'status': ReleaseStatusFromJSON(json['status']),
    };
}

export function DropReleaseToJSON(json: any): DropRelease {
    return DropReleaseToJSONTyped(json, false);
}

export function DropReleaseToJSONTyped(value?: DropRelease | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'releaseDate': value['releaseDate'],
        'status': ReleaseStatusToJSON(value['status']),
    };
}

